module.exports = __webpack_public_path__ + "static/logos/surf-forecast__logo--clear-5490895c38b60a7b4d391e12479ef725.svg";